import type { ReactNode } from 'react';
import { Button } from 'ui/components/button';

interface WizardActionsProps {
	onCancel?: () => void;
	onBack?: () => void;
	onSubmit?: () => void;
	cancelLabel?: string;
	backLabel?: string;
	submitLabel?: string;
	submitDisabled?: boolean;
	submitLoading?: boolean;
	/** Reemplaza al botón de avanzar (p. ej. "Aceptar" una vez finalizada la operación). */
	submitSlot?: ReactNode;
	'data-testid'?: string;
}

/** Extensión local: botonera Cancelar / Atrás / Siguiente de los asistentes; reemplaza a `ButtonDecline`, `ButtonNextPrev` y `ButtonConfirm`. */
export function WizardActions({
	onCancel,
	onBack,
	onSubmit,
	cancelLabel = 'Cancelar',
	backLabel = 'Atrás',
	submitLabel = 'Siguiente',
	submitDisabled,
	submitLoading,
	submitSlot,
	'data-testid': testId = 'wizard-actions'
}: WizardActionsProps) {
	return (
		<div
			data-testid={testId}
			className="mt-6 flex flex-wrap justify-center gap-3">
			{onCancel && (
				<Button
					type="button"
					variant="outline"
					onClick={onCancel}>
					{cancelLabel}
				</Button>
			)}
			{onBack && (
				<Button
					type="button"
					variant="secondary"
					onClick={onBack}>
					{backLabel}
				</Button>
			)}
			{submitSlot ??
				(onSubmit && (
					<Button
						type="button"
						disabled={submitDisabled}
						loading={submitLoading}
						onClick={onSubmit}>
						{submitLabel}
					</Button>
				))}
		</div>
	);
}
